import { EdgeProps, BaseEdge, EdgeLabelRenderer, getSmoothStepPath, Position } from '@xyflow/react';
import styles from './BranchEdge.module.scss';
import clsx from 'clsx';

interface BranchEdgeData {
    branch: 'yes' | 'no';
    [key: string]: unknown;
}

const BranchEdge = ({ id, sourceX, sourceY, targetX, targetY, data }: EdgeProps) => {
    const { branch } = data as BranchEdgeData;

    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Bottom,
        targetX,
        targetY,
        targetPosition: Position.Top,
        borderRadius: 12
    });

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                style={{ stroke: '#d1d5db', strokeWidth: 2 }}
            />
            <EdgeLabelRenderer>
                <div
                    className={clsx(styles.label, branch === 'yes' ? styles.yes : styles.no)}
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                        pointerEvents: 'none'
                    }}
                >
                    {branch === 'yes' ? 'Yes' : 'No'}
                </div>
            </EdgeLabelRenderer>
        </>
    );
};

export default BranchEdge;
